export default __webpack_public_path__ + "static/media/038-kvass.eba4e8ea.svg";